import React from 'react';
import { Icon } from '../../elements/icon';

const ProductHighlightPill = ({ children }) => (
  <div className="t-flex t-w-fit t-max-w-full t-items-center t-gap-1 t-rounded-full t-border t-border-[#C7EADF] t-bg-[#EAF7F4] t-p-2 t-font-sans t-text-xs t-leading-tight t-text-navy">
    <span className="t-flex t-h-4 t-w-4 t-flex-none t-items-center t-justify-center t-rounded-full t-bg-[#168766]">
      <Icon raw name="quizEmailCheck" size={12} color="#FFFFFF" />
    </span>
    <span>{children}</span>
  </div>
);

export default ProductHighlightPill;
